import { useEffect, useMemo, useState } from "react";

import usePlannerV2VisitGetById from "../screens/PlannerV2Screen/PlannerV2VisitDetailScreen/hooks/usePlannerV2VisitGetById";
import { isCarpoolableTravelGroup } from "../util/isCarpoolableTravelGroup";

export function usePlannerV2VisitDetailData(onDate: string, plannerVisitId: string) {
    const {
        data: { visit, possibleTimeslots, plannedOnDates, travelGroups, mapElements },
        loading,
        error,
    } = usePlannerV2VisitGetById({
        onDate,
        plannerVisitId,
    });

    const [selectedTimeslotId, setSelectedTimeslotId] = useState<string | undefined>(undefined);

    // if we have no timeslot assigned, use the first possible timeslot as default
    useEffect(() => {
        setSelectedTimeslotId(visit?.timeslotId ?? possibleTimeslots?.[0]?._id);
    }, [visit?.timeslotId, possibleTimeslots]);

    // Extract assigned fieldworkers for panel display
    const fieldworkersInAllTravelGroups = useMemo(() => {
        if (!travelGroups) return undefined;

        return travelGroups.flatMap(travelGroup => {
            return travelGroup.plannerShifts.flatMap(shift => {
                const isOwner = travelGroup.ownerPlannerShift?.fieldworker.id === shift.fieldworker.id;
                return {
                    ...shift.fieldworker,
                    isOwner,
                    ownerBillingType: travelGroup.ownerBillingType,
                };
            });
        });
    }, [travelGroups]);

    const fieldworkerAssignedToVisit = useMemo(() => {
        return visit?.fieldworkersStaged;
    }, [visit]);

    const carpoolableTravelGroups = useMemo(() => travelGroups?.filter(isCarpoolableTravelGroup), [travelGroups]);

    return {
        visit,
        possibleTimeslots,
        travelGroups,
        carpoolableTravelGroups,
        fieldworkersInAllTravelGroups,
        fieldworkerAssignedToVisit,
        routes: mapElements?.plannerTravels,
        selectedTimeslotId,
        setSelectedTimeslotId,
        loading,
        error,
        plannedOnDates: plannedOnDates ?? [],
    };
}
